<div [class]="'chips ' + type()" [class.hover]="hover()">
    <ng-content></ng-content>
</div>
